module.exports = __webpack_public_path__ + "img/213.7f44aa6d.jpg";